"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowRadioEdit_1 = require("../../../../../../shared/components/editors/CardRowRadioEdit");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var PartnerEditor = /** @class */ (function (_super) {
    __extends(PartnerEditor, _super);
    function PartnerEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_contacts = "contacts";
        return _this;
    }
    PartnerEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.partner) {
            var _item = this.props.data.getById(this.props.partner.key);
            if (_item) {
                this.setState({
                    login: _item.login,
                    password: "",
                    name: _item.name,
                    surname: _item.surname,
                    fathername: _item.fathername,
                    email: _item.email,
                    phone: _item.phone,
                    skype: _item.skype,
                    is_locked: _item.is_locked,
                    birthday_day: _item.birthday_day,
                    birthday_month: _item.birthday_month,
                    birthday_year: _item.birthday_year,
                    sex: _item.sex,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    affilate_id: _item.affilate_id,
                    affilate_title: _item.affilate_title,
                    description: _item.description,
                    is_for_brand_stat: _item.is_for_brand_stat,
                    is_email_confirmed: _item.is_email_confirmed,
                    offer_inheritance_type_code: _item.offer_inheritance_type_code,
                    offer_inheritance_type_title: _item.offer_inheritance_type_title,
                    is_allow_to_control_streamers: _item.is_allow_to_control_streamers,
                    is_all_partner_players_is_suspicious: _item.is_all_partner_players_is_suspicious,
                    is_log_partner_player_actions: _item.is_log_partner_player_actions,
                    is_consider_registration_after_auth_only: _item.is_consider_registration_after_auth_only,
                    is_allow_to_show_full_length_reports: _item.is_allow_to_show_full_length_reports,
                    tabKey: this.key_main,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование партнера"]);
                });
            }
        }
        else {
            this.setState({
                login: "",
                password: "",
                name: "",
                surname: "",
                fathername: "",
                email: "",
                phone: "",
                skype: "",
                is_locked: false,
                birthday_day: 26,
                birthday_month: 4,
                birthday_year: 1998,
                sex: "M",
                app_currency_id: 0,
                app_currency_title: "",
                app_language_id: 0,
                app_language_title: "",
                affilate_id: 0,
                affilate_title: "",
                description: "",
                tabKey: this.key_main,
                is_for_brand_stat: false,
                is_email_confirmed: false,
                offer_inheritance_type_code: 0,
                offer_inheritance_type_title: "",
                is_allow_to_control_streamers: false,
                is_all_partner_players_is_suspicious: false,
                is_log_partner_player_actions: false,
                is_consider_registration_after_auth_only: false,
                is_allow_to_show_full_length_reports: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание партнера"]);
            });
        }
        this.doReSetRules();
    };
    PartnerEditor.prototype.doReSetRules = function () {
        this.setState({
            login_rules: { isError: false },
            app_currency_rules: { isError: false },
            app_language_rules: { isError: false },
            affilate_rules: { isError: false },
            password_rules: { isError: false },
            offer_inheritance_type_rules: { isError: false }
        });
    };
    PartnerEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.partner.key,
                name: this.state.name,
                surname: this.state.surname,
                fathername: this.state.fathername,
                email: this.state.email,
                phone: this.state.phone,
                skype: this.state.skype,
                birthday_day: this.state.birthday_day,
                birthday_month: this.state.birthday_month,
                birthday_year: this.state.birthday_year,
                is_locked: this.state.is_locked,
                sex: this.state.sex,
                description: this.state.description,
                app_language_id: this.state.app_language_id,
                is_for_brand_stat: this.state.is_for_brand_stat,
                is_email_confirmed: this.state.is_email_confirmed,
                offer_inheritance_type_code: this.state.offer_inheritance_type_code,
                is_allow_to_control_streamers: this.state.is_allow_to_control_streamers,
                is_all_partner_players_is_suspicious: this.state.is_all_partner_players_is_suspicious,
                is_log_partner_player_actions: this.state.is_log_partner_player_actions,
                is_consider_registration_after_auth_only: this.state.is_consider_registration_after_auth_only,
                is_allow_to_show_full_length_reports: this.state.is_allow_to_show_full_length_reports
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнер изменен!");
            });
        }
    };
    PartnerEditor.prototype.isDataValid = function () {
        if ((this.state.affilate_id <= 0) || (this.state.affilate_title.length === 0)) {
            this.setState({
                affilate_rules: { isError: true, errorMessage: "Поле [П.Программа] не выбрано!" },
                tabKey: this.key_main
            });
            return;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: { isError: true, errorMessage: "Поле [валюта] не выбрано!" },
                tabKey: this.key_main
            });
            return;
        }
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({
                app_language_rules: { isError: true, errorMessage: "Поле [язык] не выбрано!" },
                tabKey: this.key_main
            });
            return;
        }
        if ((!this.state.login) || (this.state.login.length === 0)) {
            this.setState({
                login_rules: { isError: true, errorMessage: "Поле [логин] не заполнено!" },
                tabKey: this.key_main
            });
            return;
        }
        if (!this.isOpen4Edit()) {
            if ((!this.state.password) || (this.state.password.length === 0)) {
                this.setState({
                    password_rules: { isError: true, errorMessage: "Поле [пароль] не заполнено!" },
                    tabKey: this.key_main
                });
                return;
            }
        }
        if ((this.state.offer_inheritance_type_code <= 0) || (this.state.offer_inheritance_type_title.length === 0)) {
            this.setState({
                offer_inheritance_type_rules: { isError: true, errorMessage: "Поле [наследование оффера] не выбрано!" },
                tabKey: this.key_main
            });
            return;
        }
        return true;
    };
    PartnerEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                login: this.state.login,
                password: this.state.password,
                name: this.state.name,
                surname: this.state.surname,
                fathername: this.state.fathername,
                email: this.state.email,
                phone: this.state.phone,
                skype: this.state.skype,
                is_locked: this.state.is_locked,
                birthday_day: this.state.birthday_day,
                birthday_month: this.state.birthday_month,
                birthday_year: this.state.birthday_year,
                sex: this.state.sex,
                app_currency_id: this.state.app_currency_id,
                affilate_id: this.state.affilate_id,
                app_language_id: this.state.app_language_id,
                description: this.state.description,
                is_for_brand_stat: this.state.is_for_brand_stat,
                is_email_confirmed: this.state.is_email_confirmed,
                offer_inheritance_type_code: this.state.offer_inheritance_type_code,
                is_allow_to_control_streamers: this.state.is_allow_to_control_streamers,
                is_all_partner_players_is_suspicious: this.state.is_all_partner_players_is_suspicious,
                is_log_partner_player_actions: this.state.is_log_partner_player_actions,
                is_consider_registration_after_auth_only: this.state.is_consider_registration_after_auth_only,
                is_allow_to_show_full_length_reports: this.state.is_allow_to_show_full_length_reports
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнер создан!");
            });
        }
    };
    PartnerEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnerEditor.prototype.getFormTitle = function () {
        if (!this.props.partner) {
            return "Новый партнер";
        }
        else {
            return "Изменить партнера";
        }
    };
    PartnerEditor.prototype.isOpen4Edit = function () {
        if (!this.props.partner) {
            return false;
        }
        else {
            return true;
        }
    };
    PartnerEditor.prototype.doGeneratePassWord = function () {
        var _this = this;
        this.props.data.GeneratePartnerPassword(function (pwd) {
            _this.setState({ password: pwd }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Пароль сгенерирован!");
            });
        });
    };
    PartnerEditor.prototype.getContactsContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Skype партнера:", placeholder: "Введите Skype партнера" }, value: this.state.skype, onValueChanged: function (newVal) { _this.setState({ skype: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Email партнера:", placeholder: "Введите Email партнера" }, value: this.state.email, onValueChanged: function (newVal) { _this.setState({ email: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Телефон партнера:", placeholder: "Введите телефон партнера" }, value: this.state.phone, onValueChanged: function (newVal) { _this.setState({ phone: newVal }); } }),
            this.getDownButtons()));
    };
    PartnerEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин партнера:", placeholder: "Введите логин" }, value: this.state.login, onValueChanged: function (newVal) {
                    _this.setState({
                        login: newVal,
                        login_rules: { isError: false }
                    });
                }, disabled: this.isOpen4Edit(), required: true, rules: this.state.login_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Пароль партнера:",
                    placeholder: "Введите пароль",
                    buttonHint: "Сгенерировать пароль"
                }, disabled: this.isOpen4Edit(), onButtonClick: this.doGeneratePassWord.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        password: newVal,
                        password_rules: { isError: false }
                    });
                }, value: this.state.password, buttonIcon: "key", required: !this.isOpen4Edit(), rules: this.state.password_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа :", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.affilate_id, value: this.state.affilate_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        affilate_id: newVal.key,
                        affilate_title: newVal.value,
                        affilate_rules: { isError: false }
                    });
                }, items: this.props.affilatesAvail, disabled: this.isOpen4Edit(), required: true, rules: this.state.affilate_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта :", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.appCurrencyAvail, disabled: this.isOpen4Edit(), required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык :", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.appLanguageAvail, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Внутренний партнер(для отчетов)", value: this.state.is_for_brand_stat, onChecked: function (checked) { _this.setState({ is_for_brand_stat: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Партнер заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Наследование офферов :", placeholder: "Выберите тип наследования офферов" }, value: { key: this.state.offer_inheritance_type_code, value: this.state.offer_inheritance_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        offer_inheritance_type_code: newVal.key,
                        offer_inheritance_type_title: newVal.value,
                        offer_inheritance_type_rules: { isError: false }
                    });
                }, items: this.props.offerInheritanceTypesAvail, required: true, rules: this.state.offer_inheritance_type_rules }),
            this.getDownButtons()));
    };
    PartnerEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Имя партнера:", placeholder: "Введите имя партнера" }, value: this.state.name, onValueChanged: function (newVal) {
                    _this.setState({
                        name: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Фамилия партнера:", placeholder: "Введите фамилию партнера" }, value: this.state.surname, onValueChanged: function (newVal) { _this.setState({ surname: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Отчество партнера:", placeholder: "Введите отчество партнера" }, value: this.state.fathername, onValueChanged: function (newVal) { _this.setState({ fathername: newVal }); } }),
            React.createElement(CardRowRadioEdit_1.default, { items: [{ key: "M", title: "Мужской" }, { key: "F", title: "Женский" }], value: this.state.sex, onValueChanged: function (newVal) { _this.setState({ sex: newVal }); }, title: "Пол игрока: " }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата рождения", placeholder: "Выберите дату" }, value: {
                    day: this.state.birthday_day,
                    month: this.state.birthday_month,
                    year: this.state.birthday_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        birthday_day: day,
                        birthday_month: month,
                        birthday_year: year
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешено контролировать стримеров", value: this.state.is_allow_to_control_streamers, onChecked: function (checked) { _this.setState({ is_allow_to_control_streamers: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Электронная почта партнера подтверждена", value: this.state.is_email_confirmed, onChecked: function (checked) { _this.setState({ is_email_confirmed: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Считать всех игроков партнера подозрительными", value: this.state.is_all_partner_players_is_suspicious, onChecked: function (checked) { _this.setState({ is_all_partner_players_is_suspicious: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Логировать все действия игроков партнера", value: this.state.is_log_partner_player_actions, onChecked: function (checked) { _this.setState({ is_log_partner_player_actions: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Отображать регистрацию в статистике только после авторизации", value: this.state.is_consider_registration_after_auth_only, onChecked: function (checked) { _this.setState({ is_consider_registration_after_auth_only: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешать отображение отчетов без ограничения по числу записей", value: this.state.is_allow_to_show_full_length_reports, onChecked: function (checked) { _this.setState({ is_allow_to_show_full_length_reports: checked }); } }),
            this.getDownButtons()));
    };
    PartnerEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.partner != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    PartnerEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    PartnerEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey === this.key_contacts) {
            return this.getContactsContent();
        }
        return null;
    };
    PartnerEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 700, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_contacts, tab: "Контакты" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return PartnerEditor;
}(React.Component));
exports.default = PartnerEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/PartnerEditor.tsx
// module id = 2432
// module chunks = 0